import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../../../global/button/Button'
import { Text } from '../../../Typography/Typography'
import { ExpandableModalMobile } from '../ExpandableModal/ExpandableModalMobile'
import { cloneButtonBottomSheet, getSortedButtons } from '../common/helpers/button'
import { CommonModalProps, CommonModalTitleProps } from '../types'

import styles from './ActionModalMobile.module.scss'

interface ActionModalProps extends PropsWithChildren<CommonModalTitleProps & CommonModalProps> {
  renderFooter?(props: ActionModalProps): React.ReactNode[]
  onConfirm?(): void
}

export const ActionModalMobile: React.FC<PropsWithChildren<ActionModalProps>> = (props) => {
  const { t } = useTranslation()

  const { title = t('Cancel?'), isLoading, children, onConfirm, onClose } = props

  return (
    <ExpandableModalMobile
      title={title}
      isLoading={isLoading}
      renderFooter={({ onClose }) =>
        getSortedButtons({ ...props, onClose }, [
          cloneButtonBottomSheet(
            <Button appearance='primary' onClick={onConfirm}>
              {t('Yes')}
            </Button>
          ),
          cloneButtonBottomSheet(
            <Button appearance='secondary' onClick={onClose}>
              {t('No')}
            </Button>
          ),
        ])
      }
      onClose={onClose}
    >
      <div className={styles.body}>
        {children ? children : <Text>{t('Are you sure you want to cancel')}</Text>}
      </div>
    </ExpandableModalMobile>
  )
}
